module.exports = __webpack_public_path__ + "img/platinum.5df8575.jpg";